import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import FullStoryCard from "cards/containers/FullStoryCard";
import StoryCardStyles from "components/Library/StoryCard/StoryCard.css";
import { MicrodataContext } from "config/contexts";

/**
 * A compatibility layer component that allows us to use the new <FullStoryCard>
 * with old stream fetching containers. The idea is that this is a temporary
 * stopgap that can allow us to launch the new story cards with more semantic
 * markup and microdata before the rest of the stream refactor to move the
 * needle on SEO.
 */
export default function CompatStoryCard(props) {
  const { story } = props;
  const className = classNames(
    "story-card",
    { [StoryCardStyles.slideIn]: story.slideIn },
  );
  const isPermalink = !!(props.permalinkId);  // This is dumb but it's the only way to know if we're on a permalink page.

  // we rename these fields in the middleware bc numbers
  const imageCropStory = {
    ...story, 
    primary_image: story.primary_image && !!Object.keys(story.primary_image).length  && {
      ...story.primary_image,
      crops: {
        lead: {
          ...story.primary_image.crops["16x9"],
        },
        square: {
          ...story.primary_image.crops["1x1"],
        },
      },
    },
    social_image: story.social_image && !!Object.keys(story.social_image).length && {
      ...story.social_image,
      crops: {
        lead: {
          ...story.social_image.crops["16x9"],
        },
        square: {
          ...story.social_image.crops["1x1"],
        },
      },
    },
  };

  /**
   * The wrapper div has some odd attributes that need documentation:
   * - id: <TopStories /> tracks pageviews by checking the id of a story element
   *     against the id of the story. In addition, GTM uses the id format to
   *     trigger custom events against.
   * - data-permalink: <TopStories /> uses data-permalink to update the URL against.
   *     This was previously stored as a hidden element on the page but Google was
   *     scraping that for search results.
   * - data-story-id: <StoryBody /> uses this to know where to insert a new internal
   *     link.
   */
  return (
    <div className={className} data-permalink={story.permalink} data-story-id={story.id} id={story.id}>
      <MicrodataContext.Provider value={isPermalink && !props.index}>
        <FullStoryCard isFeatured={story.new_featured} {...props} story={imageCropStory} />
      </MicrodataContext.Provider>
    </div>
  );
}

CompatStoryCard.propTypes = {
  story: PropTypes.shape({
    permalink: PropTypes.string,
    id: PropTypes.string,
    new_featured: PropTypes.bool,
    slideIn: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number,
  permalinkId: PropTypes.string,
};
